import RedirectionErrorTypeEnum from '../types/enums/redirectionErrorTypeEnum';
import ErrorScreenTypeEnum from '../types/enums/errorScreenTypeEnum';

export function selectRedirectionErrorScreenType(redirectionErrorType: RedirectionErrorTypeEnum): ErrorScreenTypeEnum {
  switch(redirectionErrorType) {
    case RedirectionErrorTypeEnum.CustomerCancelled:
      return ErrorScreenTypeEnum.DataSharingCancelledError;
    case  RedirectionErrorTypeEnum.ProviderTemporarilyUnavailable:
      return ErrorScreenTypeEnum.ProviderUnavailableError;
    default:
      return ErrorScreenTypeEnum.GenericError;
  }
}